import { PAYTM_MINIAPP_INITIATE_TRANSACTION, PAYTM_MINIAPP_INITIATE_TRANSACTION_SUCCESS, PAYTM_MINIAPP_INITIATE_TRANSACTION_FAILURE, PAYTM_MINIAPP_STATUS_CHECK, PAYTM_MINIAPP_STATUS_CHECK_SUCCESS, PAYTM_MINIAPP_STATUS_CHECK_FAILURE, MINIAPP_PAYMENT_STATUS_RESET, PHONEPE_SWITCH_INITIATE_TRANSACTION, PHONEPE_SWITCH_INITIATE_TRANSACTION_SUCCESS, PHONEPE_SWITCH_INITIATE_TRANSACTION_FAILURE, PHONEPE_SWITCH_STATUS_CHECK, PHONEPE_SWITCH_STATUS_CHECK_SUCCESS, PHONEPE_SWITCH_STATUS_CHECK_FAILURE, } from '../../constants';
const initialState = {
    response: {},
    isPaytmPaymentLoading: false,
    isPaytmPayStatusLoading: false,
    isPhonepePaymentLoading: false,
    isPhonepePayStatusLoading: false,
    paytmMaxRepeatCallsCount: 0,
    phonepeMaxRepeatCallsCount: 0,
    paytmStatusResponse: {},
    phonepeStatusResponse: {},
    isPaymentCompleted: false,
    isPaymentSuccess: false,
};
const microAppPaymentReducer = (state = initialState, action) => {
    switch (action.type) {
        case PAYTM_MINIAPP_INITIATE_TRANSACTION:
            return {
                ...state,
                isPaytmPaymentLoading: true,
                paytmStatusResponse: {},
                isPaymentCompleted: false,
            };
        case PAYTM_MINIAPP_INITIATE_TRANSACTION_FAILURE:
            return {
                ...state,
                isPaytmPaymentLoading: false,
            };
        case PAYTM_MINIAPP_INITIATE_TRANSACTION_SUCCESS:
            return {
                ...state,
                isPaytmPaymentLoading: false,
                response: action.response,
            };
        case PAYTM_MINIAPP_STATUS_CHECK:
            return {
                ...state,
                isPaytmPayStatusLoading: true,
                paytmMaxRepeatCallsCount: action?.paytmMaxRepeatCallsCount || 0,
                paytmStatusResponse: {},
                isPaymentCompleted: false,
            };
        case PAYTM_MINIAPP_STATUS_CHECK_SUCCESS:
            return {
                ...state,
                isPaytmPayStatusLoading: false,
                paytmStatusResponse: action?.response,
                isPaymentCompleted: true,
                isPaymentSuccess: true,
            };
        case PAYTM_MINIAPP_STATUS_CHECK_FAILURE:
            return {
                ...state,
                isPaytmPayStatusLoading: false,
                paytmStatusResponse: action?.response,
                isPaymentCompleted: true,
                isPaymentSuccess: false,
            };
        case PHONEPE_SWITCH_INITIATE_TRANSACTION:
            return {
                ...state,
                isPhonepePaymentLoading: true,
                phonepeStatusResponse: {},
                isPaymentCompleted: false,
            };
        case PHONEPE_SWITCH_INITIATE_TRANSACTION_FAILURE:
            return {
                ...state,
                isPhonepePaymentLoading: false,
            };
        case PHONEPE_SWITCH_INITIATE_TRANSACTION_SUCCESS:
            return {
                ...state,
                isPhonepePaymentLoading: false,
                response: action.response,
            };
        case PHONEPE_SWITCH_STATUS_CHECK:
            return {
                ...state,
                isPhonepePayStatusLoading: true,
                phonepeMaxRepeatCallsCount: action?.phonepeMaxRepeatCallsCount || 0,
                phonepeStatusResponse: {},
                isPaymentCompleted: false,
            };
        case PHONEPE_SWITCH_STATUS_CHECK_SUCCESS:
            return {
                ...state,
                isPhonepePayStatusLoading: false,
                phonepeStatusResponse: action.response,
                isPaymentCompleted: true,
                isPaymentSuccess: true,
            };
        case PHONEPE_SWITCH_STATUS_CHECK_FAILURE:
            return {
                ...state,
                isPhonepePayStatusLoading: false,
                phonepeStatusResponse: action?.response,
                isPaymentCompleted: true,
                isPaymentSuccess: false,
            };
        case MINIAPP_PAYMENT_STATUS_RESET:
            return initialState;
        default:
            return state;
    }
};
export default microAppPaymentReducer;
